import { render, staticRenderFns } from "./inflowNewPage.vue?vue&type=template&id=2aea70cc&scoped=true"
import script from "./inflowNewPage.vue?vue&type=script&lang=js"
export * from "./inflowNewPage.vue?vue&type=script&lang=js"
import style0 from "./inflowNewPage.vue?vue&type=style&index=0&id=2aea70cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aea70cc",
  null
  
)

export default component.exports